import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {User} from "../../../../api";


@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class AvatarComponent implements OnInit {

  @Input() user!: User;

  constructor() { }

  ngOnInit(): void {
  }

}
